export default __webpack_public_path__ + "static/media/ferry_travel.cc642053.png";